export default __webpack_public_path__ + "static/media/s3.30cd2ac6.svg";